module.exports = __webpack_public_path__ + "img/ep-H.e0fe9de7.jpg";